// @ts-nocheck
// Intl.Segmenter not available in current (4.6.3) typescript version
import { convertSprdLocaleToIsoLocale } from '@/utils/convertSprdLocaleToIsoLocale';
import { getParams } from '@/utils/params';

let getFirstSymbol: (str: string) => string;

if (Intl.Segmenter) {
  let segmenter: Intl.Segmenter;
  getFirstSymbol = (str: string) => {
    if (!segmenter) {
      segmenter = new Intl.Segmenter(convertSprdLocaleToIsoLocale(getParams().locale), {
        granularity: 'grapheme',
      });
    }

    const segments = segmenter.segment(str)[Symbol.iterator]();
    return segments.next().value?.segment || '';
  };
} else {
  getFirstSymbol = (str: string) => str && String.fromCodePoint(str.codePointAt(0));
}

export { getFirstSymbol };
